import { bvaAPI } from 'api'
import { BrandApiResponse } from 'model/BrandApiResponse'

export const fetchHighlightedBrands = () =>
  bvaAPI.get<BrandApiResponse>('/bva', { params: { isHighlightedBrand: true } })
